import { ServiceModel } from '@modules/service/service-model';

const { fields } = ServiceModel;

export default [
  fields.name,
];
